<template>
  <v-app>
    <Header
      :empresa="empresa"
      :hidden="!this.$store.getters.getAluno.cpf"
    />
    <v-main class="ma-1">
      <router-view />
    </v-main>
    <span class="versao">versão {{ empresa.appVersion }}</span>

    <v-snackbar
      v-model="botaoAtualizacao"
      class="snacker"
      color="black--text red lighten-1"
      top
      right
      timeout="-1"
    >
      Nova versão disponivel!
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          color="white"
          v-bind="attrs"
          @click.stop="atualizarApp"
        >
          Atualizar
        </v-btn>
        <v-btn
          icon
          class="ml-4"
          @click="botaoAtualizacao = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <Footer :empresa="empresa" />
  </v-app>
</template>

<script>
import Header from './components/Site/Header';
import Footer from './components/Site/Footer';
import AlunoApi from './ws/aluno';
import CfcApi from "./ws/cfc";
import Api from './service/Api';

import {version} from '../package.json';

export default {
  name: 'App',

  components: {
    Header,
    Footer,
  },
  data: () => ({
    empresa: {
      name: 'Quadritech',
      product: 'Qclass',
      work_time:'8:30min às 17:00min',
      site: 'http://quadritech.com.br',
      phone: '(41) 3514-4900',
      appVersion: version,
    },
    atualizando: false,
    inscricao: null,
    botaoAtualizacao: false,
  }),
  created () {
    document.addEventListener('swAtualizado', this.mostraAtualizar, { once: true });
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.atualizando) return;
        this.atualizando = true;
        window.location.reload();
      });
    }
  },
  async mounted(){
    if (localStorage.getItem('token')) {
      Api.defaults.headers.codeCfc= localStorage.getItem('codeCfc');
      Api.defaults.headers.cpfAluno = localStorage.getItem('cpf');
      this.signIn(localStorage.getItem('token'));
    } else {
      this.$router.push('/login', () => { })
    }

  },
  methods: {
    async signIn(token) {
      const responseValidaToken = await AlunoApi.validaToken(token)
      if (responseValidaToken) {
        this.$store.commit('updateAluno', responseValidaToken.data);
        this.$router.push('/aluno/profile');
      } else {
        this.$router.push('/login', () => { });
      }
      const responseCfc = await CfcApi.findCfc(token);
      if (responseCfc) {
        var cfc = this.setCfc(responseCfc.data);
        this.$store.commit('updateCfc', cfc);
      } else {
        this.$router.push('/login', () => { });
      }
    },
    mostraAtualizar(e) {
      this.inscricao = e.detail;
      this.botaoAtualizacao = true;
    },
    atualizarApp() {
      this.botaoAtualizacao = false;
      if (!this.inscricao || !this.inscricao.waiting) { return; }
      this.inscricao.waiting.postMessage('skipWaiting');
    },
    setCfc(responseCfc) {
      var codeCfc = responseCfc.cfc.codigo.length > 5 ? responseCfc.cfc.codigo : responseCfc.cfc.cnpj.substring(0, 5);

      return {
        id: responseCfc.cfc.id,
        nome: responseCfc.cfc.nome_fantasia,
        cnpj: responseCfc.cfc.cnpj,
        codigo: responseCfc.cfc.codigo,
        codeCfc: codeCfc,
        uf: responseCfc.cfc.uf
      };
    }
  }
};
</script>

<style>
  .snacker > .v-snack__wrapper {
    min-height: 60px;
  }
  .versao {
    text-align: center;
    color: #B0BEC5;
  }
</style>
